export default __webpack_public_path__ + "static/PQ-website-logo-reverse-4e50f52f51a1d6b571b9f1ab11556430.png";